import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Header = forwardRef((props, ref) => {
  const [navbarExpanded, setNavbarExpanded] = useState(false);

  const [headerHeight, setHeaderHeight] = useState(0);
  const [headerY, setHeaderY] = useState(0);

  const className = classNames({
    header: true,
    [props.className]: props.className,
  });

  const updateHeaderElementDetails = () => {
    if (ref.current) {
      const { height, y } = ref.current.getBoundingClientRect();
      setHeaderY(y);
      setHeaderHeight(height);
    }
  };

  useEffect(() => {
    if (navbarExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
    }
  }, [navbarExpanded]);

  useEffect(() => {
    updateHeaderElementDetails();
  }, [props.topPosition]);

  const handleOnNavbarTogglerClick = e => {
    e.preventDefault();

    updateHeaderElementDetails();
    setNavbarExpanded(!navbarExpanded);
  };

  return (
    <header ref={ref} className={className}>
      <div className="container">
        <div className="header-left">
          {props.showNavigation && (
            <button
              className="navbar-toggler"
              type="button"
              aria-expanded={navbarExpanded}
              onClick={handleOnNavbarTogglerClick}
            >
              <span className="navbar-toggler-icon" />
            </button>
          )}
          {props.left}
        </div>

        <div className="header-center navbar-expand-lg">
          {props.showNavigation &&
            props.center &&
            props.center({ topPosition: headerY + headerHeight, navbarExpanded })}
        </div>

        <div className="header-right">{props.right}</div>
      </div>
    </header>
  );
});

Header.propTypes = {
  showNavigation: PropTypes.bool,
  topPosition: PropTypes.number,
  left: PropTypes.node,
  center: PropTypes.func,
  right: PropTypes.node,
  className: PropTypes.string,
};

Header.defaultProps = {
  topPosition: 0,
};

export default Header;
